// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"34":"758771f3","282":"4a5c52ec","398":"39984534","556":"41bfaf98","704":"4f4cde8d","814":"c9739245","821":"cb4cbae1","989":"c9637c55"}[chunkId] + ".js";
};